module.exports = __webpack_public_path__ + "static/img/14000031.30e405c9.png";